import { Product } from '../types';

// ============================================
// FUSES - COMPLETE RANGE
// ============================================

// STANDARD FUSES
export const standardFuseProducts: Product[] = [
  {
    id: "fuse-std-2",
    name: "Standard Fuse - 2 AMPS",
    slug: "standard-fuse-2a",
    category: "Fuse",
    subcategory: "Standard Fuse",
    description: "Standard automotive blade fuse, 2 Amps rating. Color-coded for easy identification.",
    partNumber: "SI00000002",
    image: "/products/fuses/standard-fuse/SI00000002.jpg",
    specifications: {
      "Type": "Standard Blade Fuse",
      "Rating": "2 AMPS",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "standard", "2a", "blade"],
    applications: ["Automotive", "Electrical Protection"],
  },
  {
    id: "fuse-std-3",
    name: "Standard Fuse - 3 AMPS",
    slug: "standard-fuse-3a",
    category: "Fuse",
    subcategory: "Standard Fuse",
    description: "Standard automotive blade fuse, 3 Amps rating.",
    partNumber: "SI00000003",
    image: "/products/fuses/standard-fuse/SI00000003.jpg",
    specifications: {
      "Type": "Standard Blade Fuse",
      "Rating": "3 AMPS",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "standard", "3a", "blade"],
    applications: ["Automotive", "Electrical Protection"],
  },
  {
    id: "fuse-std-5",
    name: "Standard Fuse - 5 AMPS",
    slug: "standard-fuse-5a",
    category: "Fuse",
    subcategory: "Standard Fuse",
    description: "Standard automotive blade fuse, 5 Amps rating.",
    partNumber: "SI00000005",
    image: "/products/fuses/standard-fuse/SI00000005.jpg",
    featured: true,
    specifications: {
      "Type": "Standard Blade Fuse",
      "Rating": "5 AMPS",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "standard", "5a", "blade"],
    applications: ["Automotive", "Electrical Protection"],
  },
  {
    id: "fuse-std-7.5",
    name: "Standard Fuse - 7.5 AMPS",
    slug: "standard-fuse-7.5a",
    category: "Fuse",
    subcategory: "Standard Fuse",
    description: "Standard automotive blade fuse, 7.5 Amps rating.",
    partNumber: "SI00000007",
    image: "/products/fuses/standard-fuse/SI00000007.jpg",
    specifications: {
      "Type": "Standard Blade Fuse",
      "Rating": "7.5 AMPS",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "standard", "7.5a", "blade"],
    applications: ["Automotive", "Electrical Protection"],
  },
  {
    id: "fuse-std-10",
    name: "Standard Fuse - 10 AMPS",
    slug: "standard-fuse-10a",
    category: "Fuse",
    subcategory: "Standard Fuse",
    description: "Standard automotive blade fuse, 10 Amps rating.",
    partNumber: "SI00000010",
    image: "/products/fuses/standard-fuse/SI00000010.jpg",
    featured: true,
    specifications: {
      "Type": "Standard Blade Fuse",
      "Rating": "10 AMPS",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "standard", "10a", "blade"],
    applications: ["Automotive", "Electrical Protection"],
  },
  {
    id: "fuse-std-15",
    name: "Standard Fuse - 15 AMPS",
    slug: "standard-fuse-15a",
    category: "Fuse",
    subcategory: "Standard Fuse",
    description: "Standard automotive blade fuse, 15 Amps rating.",
    partNumber: "SI00000015",
    image: "/products/fuses/standard-fuse/SI00000015.jpg",
    featured: true,
    specifications: {
      "Type": "Standard Blade Fuse",
      "Rating": "15 AMPS",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "standard", "15a", "blade"],
    applications: ["Automotive", "Electrical Protection"],
  },
  {
    id: "fuse-std-20",
    name: "Standard Fuse - 20 AMPS",
    slug: "standard-fuse-20a",
    category: "Fuse",
    subcategory: "Standard Fuse",
    description: "Standard automotive blade fuse, 20 Amps rating.",
    partNumber: "SI00000020",
    image: "/products/fuses/standard-fuse/SI00000020.jpg",
    featured: true,
    specifications: {
      "Type": "Standard Blade Fuse",
      "Rating": "20 AMPS",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "standard", "20a", "blade"],
    applications: ["Automotive", "Electrical Protection"],
  },
  {
    id: "fuse-std-25",
    name: "Standard Fuse - 25 AMPS",
    slug: "standard-fuse-25a",
    category: "Fuse",
    subcategory: "Standard Fuse",
    description: "Standard automotive blade fuse, 25 Amps rating.",
    partNumber: "SI00000025",
    image: "/products/fuses/standard-fuse/SI00000025.jpg",
    specifications: {
      "Type": "Standard Blade Fuse",
      "Rating": "25 AMPS",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "standard", "25a", "blade"],
    applications: ["Automotive", "Electrical Protection"],
  },
  {
    id: "fuse-std-30",
    name: "Standard Fuse - 30 AMPS",
    slug: "standard-fuse-30a",
    category: "Fuse",
    subcategory: "Standard Fuse",
    description: "Standard automotive blade fuse, 30 Amps rating.",
    partNumber: "SI00000030",
    image: "/products/fuses/standard-fuse/SI00000030.jpg",
    featured: true,
    specifications: {
      "Type": "Standard Blade Fuse",
      "Rating": "30 AMPS",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "standard", "30a", "blade"],
    applications: ["Automotive", "Electrical Protection"],
  },
  {
    id: "fuse-std-35",
    name: "Standard Fuse - 35 AMPS",
    slug: "standard-fuse-35a",
    category: "Fuse",
    subcategory: "Standard Fuse",
    description: "Standard automotive blade fuse, 35 Amps rating.",
    partNumber: "SI00000035",
    image: "/products/fuses/standard-fuse/SI00000035.jpg",
    specifications: {
      "Type": "Standard Blade Fuse",
      "Rating": "35 AMPS",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "standard", "35a", "blade"],
    applications: ["Automotive", "Electrical Protection"],
  },
  {
    id: "fuse-std-40",
    name: "Standard Fuse - 40 AMPS",
    slug: "standard-fuse-40a",
    category: "Fuse",
    subcategory: "Standard Fuse",
    description: "Standard automotive blade fuse, 40 Amps rating.",
    partNumber: "SI00000040",
    image: "/products/fuses/standard-fuse/SI00000040.jpg",
    specifications: {
      "Type": "Standard Blade Fuse",
      "Rating": "40 AMPS",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "standard", "40a", "blade"],
    applications: ["Automotive", "Electrical Protection"],
  },
];

// MINI FUSES
export const miniFuseProducts: Product[] = [
  {
    id: "fuse-mini-1",
    name: "Mini Fuse - 1 AMP",
    slug: "mini-fuse-1a",
    category: "Fuse",
    subcategory: "Mini Fuse",
    description: "Compact mini blade fuse, 1 Amp rating. Space-saving design for modern vehicles.",
    partNumber: "SI00001001",
    image: "/products/fuses/mini-fuse/SI00001001.jpg",
    specifications: {
      "Type": "Mini Blade Fuse",
      "Rating": "1 AMP",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "mini", "1a", "compact"],
    applications: ["Automotive", "Modern Vehicles"],
  },
  {
    id: "fuse-mini-2",
    name: "Mini Fuse - 2 AMPS",
    slug: "mini-fuse-2a",
    category: "Fuse",
    subcategory: "Mini Fuse",
    description: "Compact mini blade fuse, 2 Amps rating.",
    partNumber: "SI00001002",
    image: "/products/fuses/mini-fuse/SI00001002.jpg",
    specifications: {
      "Type": "Mini Blade Fuse",
      "Rating": "2 AMPS",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "mini", "2a", "compact"],
    applications: ["Automotive", "Modern Vehicles"],
  },
  {
    id: "fuse-mini-3",
    name: "Mini Fuse - 3 AMPS",
    slug: "mini-fuse-3a",
    category: "Fuse",
    subcategory: "Mini Fuse",
    description: "Compact mini blade fuse, 3 Amps rating.",
    partNumber: "SI00001003",
    image: "/products/fuses/mini-fuse/SI00001003.jpg",
    specifications: {
      "Type": "Mini Blade Fuse",
      "Rating": "3 AMPS",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "mini", "3a", "compact"],
    applications: ["Automotive", "Modern Vehicles"],
  },
  {
    id: "fuse-mini-4",
    name: "Mini Fuse - 4 AMPS",
    slug: "mini-fuse-4a",
    category: "Fuse",
    subcategory: "Mini Fuse",
    description: "Compact mini blade fuse, 4 Amps rating.",
    partNumber: "SI00001004",
    image: "/products/fuses/mini-fuse/SI00001004.jpg",
    specifications: {
      "Type": "Mini Blade Fuse",
      "Rating": "4 AMPS",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "mini", "4a", "compact"],
    applications: ["Automotive", "Modern Vehicles"],
  },
  {
    id: "fuse-mini-5",
    name: "Mini Fuse - 5 AMPS",
    slug: "mini-fuse-5a",
    category: "Fuse",
    subcategory: "Mini Fuse",
    description: "Compact mini blade fuse, 5 Amps rating.",
    partNumber: "SI00001005",
    image: "/products/fuses/mini-fuse/SI00001005.jpg",
    featured: true,
    specifications: {
      "Type": "Mini Blade Fuse",
      "Rating": "5 AMPS",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "mini", "5a", "compact"],
    applications: ["Automotive", "Modern Vehicles"],
  },
  {
    id: "fuse-mini-7.5",
    name: "Mini Fuse - 7.5 AMPS",
    slug: "mini-fuse-7.5a",
    category: "Fuse",
    subcategory: "Mini Fuse",
    description: "Compact mini blade fuse, 7.5 Amps rating.",
    partNumber: "SI00001007",
    image: "/products/fuses/mini-fuse/SI00001007.jpg",
    specifications: {
      "Type": "Mini Blade Fuse",
      "Rating": "7.5 AMPS",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "mini", "7.5a", "compact"],
    applications: ["Automotive", "Modern Vehicles"],
  },
  {
    id: "fuse-mini-10",
    name: "Mini Fuse - 10 AMPS",
    slug: "mini-fuse-10a",
    category: "Fuse",
    subcategory: "Mini Fuse",
    description: "Compact mini blade fuse, 10 Amps rating.",
    partNumber: "SI00001010",
    image: "/products/fuses/mini-fuse/SI00001010.jpg",
    featured: true,
    specifications: {
      "Type": "Mini Blade Fuse",
      "Rating": "10 AMPS",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "mini", "10a", "compact"],
    applications: ["Automotive", "Modern Vehicles"],
  },
  {
    id: "fuse-mini-15",
    name: "Mini Fuse - 15 AMPS",
    slug: "mini-fuse-15a",
    category: "Fuse",
    subcategory: "Mini Fuse",
    description: "Compact mini blade fuse, 15 Amps rating.",
    partNumber: "SI00001015",
    image: "/products/fuses/mini-fuse/SI00001015.jpg",
    featured: true,
    specifications: {
      "Type": "Mini Blade Fuse",
      "Rating": "15 AMPS",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "mini", "15a", "compact"],
    applications: ["Automotive", "Modern Vehicles"],
  },
  {
    id: "fuse-mini-20",
    name: "Mini Fuse - 20 AMPS",
    slug: "mini-fuse-20a",
    category: "Fuse",
    subcategory: "Mini Fuse",
    description: "Compact mini blade fuse, 20 Amps rating.",
    partNumber: "SI00001020",
    image: "/products/fuses/mini-fuse/SI00001020.jpg",
    featured: true,
    specifications: {
      "Type": "Mini Blade Fuse",
      "Rating": "20 AMPS",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "mini", "20a", "compact"],
    applications: ["Automotive", "Modern Vehicles"],
  },
  {
    id: "fuse-mini-25",
    name: "Mini Fuse - 25 AMPS",
    slug: "mini-fuse-25a",
    category: "Fuse",
    subcategory: "Mini Fuse",
    description: "Compact mini blade fuse, 25 Amps rating.",
    partNumber: "SI00001025",
    image: "/products/fuses/mini-fuse/SI00001025.jpg",
    specifications: {
      "Type": "Mini Blade Fuse",
      "Rating": "25 AMPS",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "mini", "25a", "compact"],
    applications: ["Automotive", "Modern Vehicles"],
  },
  {
    id: "fuse-mini-30",
    name: "Mini Fuse - 30 AMPS",
    slug: "mini-fuse-30a",
    category: "Fuse",
    subcategory: "Mini Fuse",
    description: "Compact mini blade fuse, 30 Amps rating.",
    partNumber: "SI00001030",
    image: "/products/fuses/mini-fuse/SI00001030.jpg",
    specifications: {
      "Type": "Mini Blade Fuse",
      "Rating": "30 AMPS",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "mini", "30a", "compact"],
    applications: ["Automotive", "Modern Vehicles"],
  },
  {
    id: "fuse-mini-35",
    name: "Mini Fuse - 35 AMPS",
    slug: "mini-fuse-35a",
    category: "Fuse",
    subcategory: "Mini Fuse",
    description: "Compact mini blade fuse, 35 Amps rating.",
    partNumber: "SI00001035",
    image: "/products/fuses/mini-fuse/SI00001035.jpg",
    specifications: {
      "Type": "Mini Blade Fuse",
      "Rating": "35 AMPS",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "mini", "35a", "compact"],
    applications: ["Automotive", "Modern Vehicles"],
  },
  {
    id: "fuse-mini-40",
    name: "Mini Fuse - 40 AMPS",
    slug: "mini-fuse-40a",
    category: "Fuse",
    subcategory: "Mini Fuse",
    description: "Compact mini blade fuse, 40 Amps rating.",
    partNumber: "SI00001040",
    image: "/products/fuses/mini-fuse/SI00001040.jpg",
    specifications: {
      "Type": "Mini Blade Fuse",
      "Rating": "40 AMPS",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "mini", "40a", "compact"],
    applications: ["Automotive", "Modern Vehicles"],
  },
];

// SLOW BLOW FEMALE FUSES
export const slowBlowFemaleFuseProducts: Product[] = [
  {
    id: "fuse-sbf-20",
    name: "Slow Blow Female Fuse - 20 AMPS",
    slug: "slow-blow-female-20a",
    category: "Fuse",
    subcategory: "Slow Blow Female Fuse",
    description: "Slow blow female cartridge fuse, 20 Amps. Time-delay fuse for inductive loads.",
    partNumber: "SI00002020",
    image: "/products/fuses/slow-blow-female-fuse/SI00002020.jpg",
    specifications: {
      "Type": "Slow Blow Female Cartridge",
      "Rating": "20 AMPS",
      "Feature": "Time Delay",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "slow-blow", "female", "20a"],
    applications: ["Audio Systems", "Motor Circuits", "Inductive Loads"],
  },
  {
    id: "fuse-sbf-30",
    name: "Slow Blow Female Fuse - 30 AMPS",
    slug: "slow-blow-female-30a",
    category: "Fuse",
    subcategory: "Slow Blow Female Fuse",
    description: "Slow blow female cartridge fuse, 30 Amps.",
    partNumber: "SI00002030",
    image: "/products/fuses/slow-blow-female-fuse/SI00002030.jpg",
    featured: true,
    specifications: {
      "Type": "Slow Blow Female Cartridge",
      "Rating": "30 AMPS",
      "Feature": "Time Delay",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "slow-blow", "female", "30a"],
    applications: ["Audio Systems", "Motor Circuits"],
  },
  {
    id: "fuse-sbf-40",
    name: "Slow Blow Female Fuse - 40 AMPS",
    slug: "slow-blow-female-40a",
    category: "Fuse",
    subcategory: "Slow Blow Female Fuse",
    description: "Slow blow female cartridge fuse, 40 Amps.",
    partNumber: "SI00002040",
    image: "/products/fuses/slow-blow-female-fuse/SI00002040.jpg",
    specifications: {
      "Type": "Slow Blow Female Cartridge",
      "Rating": "40 AMPS",
      "Feature": "Time Delay",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "slow-blow", "female", "40a"],
    applications: ["Audio Systems", "Motor Circuits"],
  },
  {
    id: "fuse-sbf-50",
    name: "Slow Blow Female Fuse - 50 AMPS",
    slug: "slow-blow-female-50a",
    category: "Fuse",
    subcategory: "Slow Blow Female Fuse",
    description: "Slow blow female cartridge fuse, 50 Amps.",
    partNumber: "SI00002050",
    image: "/products/fuses/slow-blow-female-fuse/SI00002050.jpg",
    specifications: {
      "Type": "Slow Blow Female Cartridge",
      "Rating": "50 AMPS",
      "Feature": "Time Delay",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "slow-blow", "female", "50a"],
    applications: ["Audio Systems", "Motor Circuits"],
  },
  {
    id: "fuse-sbf-60",
    name: "Slow Blow Female Fuse - 60 AMPS",
    slug: "slow-blow-female-60a",
    category: "Fuse",
    subcategory: "Slow Blow Female Fuse",
    description: "Slow blow female cartridge fuse, 60 Amps.",
    partNumber: "SI00002060",
    image: "/products/fuses/slow-blow-female-fuse/SI00002060.jpg",
    featured: true,
    specifications: {
      "Type": "Slow Blow Female Cartridge",
      "Rating": "60 AMPS",
      "Feature": "Time Delay",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "slow-blow", "female", "60a"],
    applications: ["Audio Systems", "High Power Circuits"],
  },
  {
    id: "fuse-sbf-70",
    name: "Slow Blow Female Fuse - 70 AMPS",
    slug: "slow-blow-female-70a",
    category: "Fuse",
    subcategory: "Slow Blow Female Fuse",
    description: "Slow blow female cartridge fuse, 70 Amps.",
    partNumber: "SI00002070",
    image: "/products/fuses/slow-blow-female-fuse/SI00002070.jpg",
    specifications: {
      "Type": "Slow Blow Female Cartridge",
      "Rating": "70 AMPS",
      "Feature": "Time Delay",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "slow-blow", "female", "70a"],
    applications: ["Audio Systems", "High Power Circuits"],
  },
  {
    id: "fuse-sbf-80",
    name: "Slow Blow Female Fuse - 80 AMPS",
    slug: "slow-blow-female-80a",
    category: "Fuse",
    subcategory: "Slow Blow Female Fuse",
    description: "Slow blow female cartridge fuse, 80 Amps.",
    partNumber: "SI00002080",
    image: "/products/fuses/slow-blow-female-fuse/SI00002080.jpg",
    specifications: {
      "Type": "Slow Blow Female Cartridge",
      "Rating": "80 AMPS",
      "Feature": "Time Delay",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "slow-blow", "female", "80a"],
    applications: ["Audio Systems", "High Power Circuits"],
  },
  {
    id: "fuse-sbf-100",
    name: "Slow Blow Female Fuse - 100 AMPS",
    slug: "slow-blow-female-100a",
    category: "Fuse",
    subcategory: "Slow Blow Female Fuse",
    description: "Slow blow female cartridge fuse, 100 Amps.",
    partNumber: "SI00002100",
    image: "/products/fuses/slow-blow-female-fuse/SI00002100.jpg",
    featured: true,
    specifications: {
      "Type": "Slow Blow Female Cartridge",
      "Rating": "100 AMPS",
      "Feature": "Time Delay",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "slow-blow", "female", "100a"],
    applications: ["Audio Systems", "High Power Circuits"],
  },
];

// GLASS FUSES
export const glassFuseProducts: Product[] = [
  {
    id: "fuse-glass-range",
    name: "Glass Fuse - 10A to 100A Range",
    slug: "glass-fuse-range",
    category: "Fuse",
    subcategory: "Glass Fuse",
    description: "Glass tube fuses for automotive and electronic applications. Available in ratings from 10A to 100A. Clear glass body for visual inspection.",
    partNumber: "SI00003010-SI00003100",
    image: "/products/fuses/glass-fuse/SI00003010-SI00003100.jpg",
    featured: true,
    specifications: {
      "Type": "Glass Tube Fuse",
      "Available Ratings": "10A, 20A, 30A, 40A, 50A, 60A, 70A, 80A, 90A, 100A",
      "Feature": "Visual inspection",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "glass", "tube", "visual"],
    applications: ["Automotive", "Electronics", "Vintage Vehicles"],
  },
];

// SLOW BLOW MALE FUSES
export const slowBlowMaleFuseProducts: Product[] = [
  {
    id: "fuse-sbm-20",
    name: "Slow Blow Male Fuse - 20 AMPS",
    slug: "slow-blow-male-20a",
    category: "Fuse",
    subcategory: "Slow Blow Male Fuse",
    description: "Slow blow male cartridge fuse, 20 Amps. Time-delay protection.",
    partNumber: "SI00004020",
    image: "/products/fuses/slow-blow-male-fuse/SI00004020.jpg",
    specifications: {
      "Type": "Slow Blow Male Cartridge",
      "Rating": "20 AMPS",
      "Feature": "Time Delay",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "slow-blow", "male", "20a"],
    applications: ["Audio Systems", "Motor Circuits"],
  },
  {
    id: "fuse-sbm-30",
    name: "Slow Blow Male Fuse - 30 AMPS",
    slug: "slow-blow-male-30a",
    category: "Fuse",
    subcategory: "Slow Blow Male Fuse",
    description: "Slow blow male cartridge fuse, 30 Amps.",
    partNumber: "SI00004030",
    image: "/products/fuses/slow-blow-male-fuse/SI00004030.jpg",
    featured: true,
    specifications: {
      "Type": "Slow Blow Male Cartridge",
      "Rating": "30 AMPS",
      "Feature": "Time Delay",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "slow-blow", "male", "30a"],
    applications: ["Audio Systems", "Motor Circuits"],
  },
  {
    id: "fuse-sbm-40",
    name: "Slow Blow Male Fuse - 40 AMPS",
    slug: "slow-blow-male-40a",
    category: "Fuse",
    subcategory: "Slow Blow Male Fuse",
    description: "Slow blow male cartridge fuse, 40 Amps.",
    partNumber: "SI00004040",
    image: "/products/fuses/slow-blow-male-fuse/SI00004040.jpg",
    specifications: {
      "Type": "Slow Blow Male Cartridge",
      "Rating": "40 AMPS",
      "Feature": "Time Delay",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "slow-blow", "male", "40a"],
    applications: ["Audio Systems", "Motor Circuits"],
  },
  {
    id: "fuse-sbm-50",
    name: "Slow Blow Male Fuse - 50 AMPS",
    slug: "slow-blow-male-50a",
    category: "Fuse",
    subcategory: "Slow Blow Male Fuse",
    description: "Slow blow male cartridge fuse, 50 Amps.",
    partNumber: "SI00004050",
    image: "/products/fuses/slow-blow-male-fuse/SI00004050.jpg",
    specifications: {
      "Type": "Slow Blow Male Cartridge",
      "Rating": "50 AMPS",
      "Feature": "Time Delay",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "slow-blow", "male", "50a"],
    applications: ["Audio Systems", "Motor Circuits"],
  },
  {
    id: "fuse-sbm-60",
    name: "Slow Blow Male Fuse - 60 AMPS",
    slug: "slow-blow-male-60a",
    category: "Fuse",
    subcategory: "Slow Blow Male Fuse",
    description: "Slow blow male cartridge fuse, 60 Amps.",
    partNumber: "SI00004060",
    image: "/products/fuses/slow-blow-male-fuse/SI00004060.jpg",
    featured: true,
    specifications: {
      "Type": "Slow Blow Male Cartridge",
      "Rating": "60 AMPS",
      "Feature": "Time Delay",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "slow-blow", "male", "60a"],
    applications: ["Audio Systems", "High Power Circuits"],
  },
  {
    id: "fuse-sbm-70",
    name: "Slow Blow Male Fuse - 70 AMPS",
    slug: "slow-blow-male-70a",
    category: "Fuse",
    subcategory: "Slow Blow Male Fuse",
    description: "Slow blow male cartridge fuse, 70 Amps.",
    partNumber: "SI00004070",
    image: "/products/fuses/slow-blow-male-fuse/SI00004070.jpg",
    specifications: {
      "Type": "Slow Blow Male Cartridge",
      "Rating": "70 AMPS",
      "Feature": "Time Delay",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "slow-blow", "male", "70a"],
    applications: ["Audio Systems", "High Power Circuits"],
  },
  {
    id: "fuse-sbm-80",
    name: "Slow Blow Male Fuse - 80 AMPS",
    slug: "slow-blow-male-80a",
    category: "Fuse",
    subcategory: "Slow Blow Male Fuse",
    description: "Slow blow male cartridge fuse, 80 Amps.",
    partNumber: "SI00004080",
    image: "/products/fuses/slow-blow-male-fuse/SI00004080.jpg",
    specifications: {
      "Type": "Slow Blow Male Cartridge",
      "Rating": "80 AMPS",
      "Feature": "Time Delay",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "slow-blow", "male", "80a"],
    applications: ["Audio Systems", "High Power Circuits"],
  },
  {
    id: "fuse-sbm-100",
    name: "Slow Blow Male Fuse - 100 AMPS",
    slug: "slow-blow-male-100a",
    category: "Fuse",
    subcategory: "Slow Blow Male Fuse",
    description: "Slow blow male cartridge fuse, 100 Amps.",
    partNumber: "SI00004100",
    image: "/products/fuses/slow-blow-male-fuse/SI00004100.jpg",
    featured: true,
    specifications: {
      "Type": "Slow Blow Male Cartridge",
      "Rating": "100 AMPS",
      "Feature": "Time Delay",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "slow-blow", "male", "100a"],
    applications: ["Audio Systems", "High Power Circuits"],
  },
];

// MIDI FUSES
export const midiFuseProducts: Product[] = [
  {
    id: "fuse-midi-range",
    name: "Midi Fuse - 20A to 100A Range",
    slug: "midi-fuse-range",
    category: "Fuse",
    subcategory: "Midi Fuse",
    description: "Midi blade fuses for medium to high current applications. Compact design with high amperage rating. Available in 20A to 100A.",
    partNumber: "SI00005020-SI00005100",
    featured: true,
    specifications: {
      "Type": "Midi Blade Fuse",
      "Available Ratings": "20A, 30A, 40A, 50A, 60A, 70A, 80A, 90A, 100A",
      "Application": "Medium-High Current",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "midi", "high-current"],
    applications: ["Automotive", "Heavy Current", "Power Distribution"],
    image: "/products/fuses/midi-fuse/SI00005020-SI00005100.jpg",
  },
];

// MEGA FUSES
export const megaFuseProducts: Product[] = [
  {
    id: "fuse-mega-range",
    name: "Mega Fuse - 50A to 500A Range",
    slug: "mega-fuse-range",
    category: "Fuse",
    subcategory: "Mega Fuse",
    description: "Mega blade fuses for very high current applications. Designed for main power distribution. Available from 50A to 500A.",
    partNumber: "SI00006050-SI00006500",
    featured: true,
    specifications: {
      "Type": "Mega Blade Fuse",
      "Available Ratings": "50A, 60A, 80A, 100A, 150A, 200A, 300A, 500A",
      "Application": "Very High Current",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "mega", "very-high-current", "power-distribution"],
    applications: ["Commercial Vehicles", "Heavy Machinery", "Main Power Distribution"],
    image: "/products/fuses/mega-fuse/SI00006050-SI00006500.jpg",
  },
];

// ANL FUSES
export const anlFuseProducts: Product[] = [
  {
    id: "fuse-anl-range",
    name: "ANL Fuse - 20A to 150A Range",
    slug: "anl-fuse-range",
    category: "Fuse",
    subcategory: "ANL Fuse",
    description: "ANL (American National Limits) fuses for high current protection. Commonly used in automotive audio and power systems. Available from 20A to 150A.",
    partNumber: "SI00007020-SI00007150",
    featured: true,
    specifications: {
      "Type": "ANL Fuse",
      "Available Ratings": "20A, 30A, 40A, 50A, 60A, 80A, 100A, 120A, 150A",
      "Application": "Audio & Power Systems",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "anl", "audio", "high-power"],
    applications: ["Car Audio", "Power Systems", "High Current Protection"],
    image: "/products/fuses/anl-fuse/SI00007020-SI00007150.jpg",
  },
];

// OTHER FUSES (BOLT-DOWN TYPE)
export const boltDownFuseProducts: Product[] = [
  {
    id: "fuse-bolt-20",
    name: "Bolt-Down Fuse - 20 AMPS",
    slug: "bolt-down-fuse-20a",
    category: "Fuse",
    subcategory: "Bolt-Down Fuse",
    description: "Heavy-duty bolt-down fuse, 20 Amps. Secure mounting for vibration-resistant applications.",
    partNumber: "SI00008020",
    image: "/products/fuses/other-fuse/SI00008020.jpg",
    specifications: {
      "Type": "Bolt-Down",
      "Rating": "20 AMPS",
      "Mounting": "Bolt-on",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "bolt-down", "20a", "heavy-duty"],
    applications: ["Commercial Vehicles", "Marine", "Industrial"],
  },
  {
    id: "fuse-bolt-25",
    name: "Bolt-Down Fuse - 25 AMPS",
    slug: "bolt-down-fuse-25a",
    category: "Fuse",
    subcategory: "Bolt-Down Fuse",
    description: "Heavy-duty bolt-down fuse, 25 Amps.",
    partNumber: "SI00008025",
    image: "/products/fuses/other-fuse/SI00008025.jpg",
    specifications: {
      "Type": "Bolt-Down",
      "Rating": "25 AMPS",
      "Mounting": "Bolt-on",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "bolt-down", "25a", "heavy-duty"],
    applications: ["Commercial Vehicles", "Marine", "Industrial"],
  },
  {
    id: "fuse-bolt-30",
    name: "Bolt-Down Fuse - 30 AMPS",
    slug: "bolt-down-fuse-30a",
    category: "Fuse",
    subcategory: "Bolt-Down Fuse",
    description: "Heavy-duty bolt-down fuse, 30 Amps.",
    partNumber: "SI00008030",
    image: "/products/fuses/other-fuse/SI00008030.jpg",
    featured: true,
    specifications: {
      "Type": "Bolt-Down",
      "Rating": "30 AMPS",
      "Mounting": "Bolt-on",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "bolt-down", "30a", "heavy-duty"],
    applications: ["Commercial Vehicles", "Marine", "Industrial"],
  },
  {
    id: "fuse-bolt-40",
    name: "Bolt-Down Fuse - 40 AMPS",
    slug: "bolt-down-fuse-40a",
    category: "Fuse",
    subcategory: "Bolt-Down Fuse",
    description: "Heavy-duty bolt-down fuse, 40 Amps.",
    partNumber: "SI00008040",
    image: "/products/fuses/other-fuse/SI00008040.jpg",
    specifications: {
      "Type": "Bolt-Down",
      "Rating": "40 AMPS",
      "Mounting": "Bolt-on",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "bolt-down", "40a", "heavy-duty"],
    applications: ["Commercial Vehicles", "Marine", "Industrial"],
  },
  {
    id: "fuse-bolt-50",
    name: "Bolt-Down Fuse - 50 AMPS",
    slug: "bolt-down-fuse-50a",
    category: "Fuse",
    subcategory: "Bolt-Down Fuse",
    description: "Heavy-duty bolt-down fuse, 50 Amps.",
    partNumber: "SI00008050",
    image: "/products/fuses/other-fuse/SI00008050.jpg",
    specifications: {
      "Type": "Bolt-Down",
      "Rating": "50 AMPS",
      "Mounting": "Bolt-on",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "bolt-down", "50a", "heavy-duty"],
    applications: ["Commercial Vehicles", "Marine", "Industrial"],
  },
  {
    id: "fuse-bolt-60",
    name: "Bolt-Down Fuse - 60 AMPS",
    slug: "bolt-down-fuse-60a",
    category: "Fuse",
    subcategory: "Bolt-Down Fuse",
    description: "Heavy-duty bolt-down fuse, 60 Amps.",
    partNumber: "SI00008060",
    image: "/products/fuses/other-fuse/SI00008060.jpg",
    specifications: {
      "Type": "Bolt-Down",
      "Rating": "60 AMPS",
      "Mounting": "Bolt-on",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "bolt-down", "60a", "heavy-duty"],
    applications: ["Commercial Vehicles", "Marine", "Industrial"],
  },
];

// MAXI FUSES
export const maxiFuseProducts: Product[] = [
  {
    id: "fuse-maxi-30",
    name: "Maxi Fuse - 30 AMPS",
    slug: "maxi-fuse-30a",
    category: "Fuse",
    subcategory: "Maxi Fuse",
    description: "Maxi blade fuse for high current circuits. Larger size for better heat dissipation. 30 Amps rating.",
    partNumber: "SI00009030",
    image: "/products/fuses/maxi-fuse/SI00009030.jpg",
    specifications: {
      "Type": "Maxi Blade Fuse",
      "Rating": "30 AMPS",
      "Feature": "High heat dissipation",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "maxi", "30a", "high-current"],
    applications: ["Automotive", "High Current Circuits"],
  },
  {
    id: "fuse-maxi-40",
    name: "Maxi Fuse - 40 AMPS",
    slug: "maxi-fuse-40a",
    category: "Fuse",
    subcategory: "Maxi Fuse",
    description: "Maxi blade fuse, 40 Amps rating.",
    partNumber: "SI00009040",
    image: "/products/fuses/maxi-fuse/SI00009040.jpg",
    featured: true,
    specifications: {
      "Type": "Maxi Blade Fuse",
      "Rating": "40 AMPS",
      "Feature": "High heat dissipation",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "maxi", "40a", "high-current"],
    applications: ["Automotive", "High Current Circuits"],
  },
  {
    id: "fuse-maxi-50",
    name: "Maxi Fuse - 50 AMPS",
    slug: "maxi-fuse-50a",
    category: "Fuse",
    subcategory: "Maxi Fuse",
    description: "Maxi blade fuse, 50 Amps rating.",
    partNumber: "SI00009050",
    image: "/products/fuses/maxi-fuse/SI00009050.jpg",
    specifications: {
      "Type": "Maxi Blade Fuse",
      "Rating": "50 AMPS",
      "Feature": "High heat dissipation",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "maxi", "50a", "high-current"],
    applications: ["Automotive", "High Current Circuits"],
  },
  {
    id: "fuse-maxi-60",
    name: "Maxi Fuse - 60 AMPS",
    slug: "maxi-fuse-60a",
    category: "Fuse",
    subcategory: "Maxi Fuse",
    description: "Maxi blade fuse, 60 Amps rating.",
    partNumber: "SI00009060",
    image: "/products/fuses/maxi-fuse/SI00009060.jpg",
    featured: true,
    specifications: {
      "Type": "Maxi Blade Fuse",
      "Rating": "60 AMPS",
      "Feature": "High heat dissipation",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "maxi", "60a", "high-current"],
    applications: ["Automotive", "High Current Circuits"],
  },
  {
    id: "fuse-maxi-70",
    name: "Maxi Fuse - 70 AMPS",
    slug: "maxi-fuse-70a",
    category: "Fuse",
    subcategory: "Maxi Fuse",
    description: "Maxi blade fuse, 70 Amps rating.",
    partNumber: "SI00009070",
    image: "/products/fuses/maxi-fuse/SI00009070.jpg",
    specifications: {
      "Type": "Maxi Blade Fuse",
      "Rating": "70 AMPS",
      "Feature": "High heat dissipation",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "maxi", "70a", "high-current"],
    applications: ["Automotive", "High Current Circuits"],
  },
  {
    id: "fuse-maxi-80",
    name: "Maxi Fuse - 80 AMPS",
    slug: "maxi-fuse-80a",
    category: "Fuse",
    subcategory: "Maxi Fuse",
    description: "Maxi blade fuse, 80 Amps rating.",
    partNumber: "SI00009080",
    image: "/products/fuses/maxi-fuse/SI00009080.jpg",
    specifications: {
      "Type": "Maxi Blade Fuse",
      "Rating": "80 AMPS",
      "Feature": "High heat dissipation",
      "Packing": "100 Pcs",
    },
    tags: ["fuse", "maxi", "80a", "high-current"],
    applications: ["Automotive", "High Current Circuits"],
  },
];
